import React from "react";
import PropTypes from "prop-types";
import { SGIcon } from "../../component";
import { isMobile } from "../../utils/global-variables";
import "./SGCardCarousel-style.css";

export const SGCardCarousel = props => {
  const contentElem = item => (
    <>
      <h3>{item.subtitle}</h3>
      <p className="content">{item.content}</p>
      <div className="more-info">
        <SGIcon
          src={require("../../assets/images/search-icon.png")}
          to="/project"
          alt="More Info"
        />
      </div>
    </>
  );
  const picElem = item => (
    <img className="carousel-pic" src={item.pictureUrl} alt="..." />
  );

  const pcItemsElem = props.carouselItems.map((item, index) => {
    let carouselItemClassName = "carousel-item ";
    if (index === 0) carouselItemClassName += "active";

    return (
      <div key={index.toString()} className={carouselItemClassName}>
        <div className="row">
          <div className="col-4 pic-col ml-5 mb-5">{picElem(item)}</div>
          <div className="col text-col mr-5">{contentElem(item)}</div>
        </div>
      </div>
    );
  });

  const mobileItemsElem = props.carouselItems.map((item, index) => {
    let carouselItemClassName = "carousel-item ";
    if (index === 0) carouselItemClassName += "active";

    return (
      <div key={index.toString()} className={carouselItemClassName}>
        <div className="row">
          <div className="col pic-col">{picElem(item)}</div>
        </div>
        <div className="row">
          <div className="col text-col">{contentElem(item)}</div>
        </div>
      </div>
    );
  });

  const pcElem = !isMobile && (
    <div
      id={props.id}
      className="carousel slide"
      data-ride="carousel"
    >
      <div className="carousel-inner to-right-gradient-bg">
        <h2 className="title mt-3">{props.title}</h2>
        {pcItemsElem}
        <ol className="carousel-indicators">
          <li
            data-target={`#${props.id}`}
            data-slide-to="0"
            className="active"
          ></li>
          <li data-target={`#${props.id}`} data-slide-to="1"></li>
        </ol>
      </div>
    </div>
  );

  const mobileElem = isMobile && (
    <div
      id={props.id}
      className="carousel slide"
      data-ride="carousel"
      data-interval="false"
    >
      <div className="carousel-inner to-right-gradient-bg">
        <div className="project-div mt-3 mb-3">
          <span
            data-slide="prev"
            href={`#${props.id}`}
            className="carousel-control-prev-icon arrow cursor-pointer"
            aria-hidden="true"
          ></span>
          <span className="sr-only">Previous</span>
          <h2 className="title">{props.title}</h2>
          <span
            href={`#${props.id}`}
            data-slide="next"
            className="carousel-control-next-icon arrow cursor-pointer"
            aria-hidden="true"
          ></span>
          <span className="sr-only">Next</span>
        </div>

        {mobileItemsElem}
      </div>
    </div>
  );

  return (
    <>
      {pcElem}
      {mobileElem}
    </>
  );
};

SGCardCarousel.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  carouselItems: PropTypes.array.isRequired // subtitle: string, content: string, pictureUrl: string or number
};
